import { LanguageISO } from 'utils/localisation'

import { AnalyticsService } from '../AnalyticsService'
import { AuthStore } from '../Auth'

export class UserlaneService {
  private appId: string
  private appEnv: string
  private authStore: AuthStore
  private analyticsService: AnalyticsService
  private isInitialized: boolean

  get isUserlaneActive(): boolean {
    return !!window.Userlane && this.isInitialized
  }

  constructor(appId: string, appEnv: string, authStore: AuthStore, analyticsService: AnalyticsService) {
    this.appId = appId
    this.appEnv = appEnv
    this.authStore = authStore
    this.analyticsService = analyticsService
    this.isInitialized = false // prevents Userlane from being used unless initialized
  }

  init() {
    if (!window.Userlane) return

    const { Userlane } = window
    const { customer, user, loggedInAsCustomer, shipmentMetadata } = this.authStore.state
    const userId = this.appEnv === 'production' ? user._id : `${this.appEnv}-${user._id}`
    const userData = {
      segment: !!customer.segment && customer.segment,
      opsLoggedInAsUser: loggedInAsCustomer,
      shipmentsBookedByUser: shipmentMetadata.bookedByUser,
      shipmentsUserIsSubscribedTo: shipmentMetadata.visibleForUser,
    }

    Userlane('identify', userId, userData)
    Userlane('lang', user.preferredLanguage)

    Userlane('onStart', (userlaneId: string) => {
      window.dataLayer.push({
        event: 'userlane-started',
        eventCategory: 'Userlane',
        eventAction: 'Started',
        userlaneId,
      })
      this.analyticsService.sendEvent('userlane-started', {
        userlaneId,
      })
    })
    Userlane('onComplete', (userlaneId: string) => {
      window.dataLayer.push({
        event: 'userlane-completed',
        eventCategory: 'Userlane',
        eventAction: 'Completed',
        userlaneId,
      })
      this.analyticsService.sendEvent('userlane-completed', {
        userlaneId,
      })
    })
    Userlane('onExit', (userlaneId: string) => {
      window.dataLayer.push({
        event: 'userlane-canceled',
        eventCategory: 'Userlane',
        eventAction: 'Canceled',
        userlaneId,
      })
      this.analyticsService.sendEvent('userlane-canceled', {
        userlaneId,
      })
    })

    Userlane('init', this.appId)

    this.isInitialized = true
  }

  start(userlaneId: string) {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('start', userlaneId)
  }

  changeLanguage(language: LanguageISO) {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('lang', language)
    Userlane('init', this.appId)
  }

  hide() {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('hide')
  }
}
